export default [
    {
        path: 'relatorio-paciente-atendido',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-paciente-atendido' */
            '@/views/exame-laboratorial/relatorio-paciente-atendido/Index'
        ),
        redirect: 'relatorio-paciente-atendido/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-paciente-atendido-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-paciente-atendido' */
                    '@/views/exame-laboratorial/relatorio-paciente-atendido/List.vue'
                ),
            },
        ],
    },
]